import axios from 'axios';

const REPORTS_BASE_URL = import.meta.env.VITE_REPORTS_URL;
const REPORTS_TOKEN = import.meta.env.VITE_REPORTS_TOKEN;

// Create a separate axios instance for jasperServer
const jasperAxios = axios.create({
    baseURL: REPORTS_BASE_URL,
    timeout: 300000,
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${REPORTS_TOKEN}`
    }
});

export default function jasperServer() {
    return {
        generateReport
    };

    function generateReport(reportData) {
        return jasperAxios.post('/reports/generate', reportData, {
            responseType: 'blob'
        });
    }
}
